module.exports = __webpack_public_path__ + "static/media/logo.26ef1cbc.svg";